<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title">{{'Tag' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Name' | translate}} *</label>
      <input class="form-control" [(ngModel)]="entity.name" />
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
